import { Checkbox } from 'components/Inputs/Checkbox';
import { MaskedInput } from 'components/Inputs/MaskedInput';
import { Switch } from 'components/Inputs/Switch';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { IPartnerCreate } from 'types/Partner';

import {
  InputAdornment,
  styled,
  TableCell as MaterialTableCell,
  TableRow,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';

const TableCell = styled(MaterialTableCell)(({ theme }) => ({
  borderBottom: 'none',
  verticalAlign: 'top',
}));

type Props = {
  day: string;
  title: string;
};

export const OpeningHoursRow: React.FC<Props> = ({ day, title, children }) => {
  const { setValue, control } = useFormContext<IPartnerCreate>();

  const getFieldName = (fieldName: string) =>
    `workingHoursUpdate.${day}.${fieldName}` as any;

  const [dayLong, open] = useWatch({
    control,
    name: [getFieldName('dayLong') as any, getFieldName('open') as any],
  });

  const handleChangeDayLong = (_: any, checked: boolean) => {
    setValue(getFieldName('start'), '', { shouldValidate: checked });
    setValue(getFieldName('end'), '', { shouldValidate: checked });
    setValue(
      getFieldName('interval'),
      { start: '', end: '' },
      { shouldValidate: checked }
    );
    setValue(getFieldName('dayLong'), checked, { shouldValidate: true });
  };

  const handleChangeOpen = (_: any, checked: boolean) => {
    setValue(getFieldName('open'), checked, { shouldValidate: true });

    if (!checked) {
      handleChangeDayLong(null, false);
    }
  };

  const disableInput = !open || dayLong;

  return (
    <TableRow>
      <TableCell>
        <Typography fontWeight="bold" sx={{ mt: 1 }}>
          {title}
        </Typography>
      </TableCell>

      <TableCell width={150}>
        <Switch
          name={getFieldName('open')}
          activeLabel="Aberto"
          inactiveLabel="Fechado"
          onChange={handleChangeOpen}
        />
      </TableCell>

      <TableCell>
        <MaskedInput
          name={getFieldName('start')}
          mask="##:##"
          placeholder="00:00"
          variant="standard"
          sx={{ width: 80, whiteSpace: 'nowrap' }}
          disabled={disableInput}
        />
      </TableCell>

      <TableCell width={130}>
        <MaskedInput
          name={getFieldName('end')}
          mask="##:##"
          placeholder="00:00"
          variant="standard"
          sx={{ width: 80, whiteSpace: 'nowrap' }}
          disabled={disableInput}
        />
      </TableCell>

      <TableCell width={200}>
        <Box flexDirection="row" display="flex">
          <MaskedInput
            name={getFieldName('interval.start')}
            mask="##:##"
            placeholder="00:00"
            variant="standard"
            sx={{ width: 80, whiteSpace: 'nowrap' }}
            disabled={disableInput}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">às</InputAdornment>
              ),
            }}
          />

          <MaskedInput
            name={getFieldName('interval.end')}
            mask="##:##"
            placeholder="00:00"
            variant="standard"
            sx={{ width: 80, whiteSpace: 'nowrap' }}
            disabled={disableInput}
          />
        </Box>
      </TableCell>

      <TableCell>
        <Checkbox
          name={getFieldName('dayLong')}
          label="24 horas"
          onChange={handleChangeDayLong}
          disabled={!open}
        />
      </TableCell>

      {children}
    </TableRow>
  );
};

